<template>
    <div>
        <b-container v-if="!isJACareerEntrepreApp" class="pt-container">
            <div id="errors" role="region" class="sr-only" aria-live="polite">
                {{ nameError ? 'Name of the project is empty and is a required field' : '' }}
            </div>
            <b-form @submit.prevent="saveProject()">
                <div class="row wrapper-step-content">
                    <b-col cols="12" :class="{'step-content-new': newProject, 'step-content-update': !newProject}">
                        <b-row class="first-form">
                            <b-col cols="12" class="px-4 welcome" aria-hidden="true">
                                {{getMessage(1, 'welcome-project-setup', 2)}}
                            </b-col>
                            <b-col cols="12" class="px-4 main-title" tabindex="0"
                                aria-label="Welcome to your J.A. Job Shadow Experience!">
                                {{getMessage(1, 'welcome-project-name', 2)}}
                            </b-col>

                            <b-col cols="12" class="px-4 instructional-text text-high-contrast" tabindex="0">
                                {{getMessage(1, 'project-text-video', 2)}}
                            </b-col>

                            <b-col cols="12" class="px-4 mt-3 text-center">
                            <JAVideo
                                :poster="{src:require('../Images/star-project.jpg'), title:'Introductory Video about J.A. Job Shadow Experience for Students'}"
                                title="JA Job Shadow Experience"
                                :sources="[{
                                src: 'https://jad4dmedia-usso.streaming.media.azure.net/a2f9d4ca-da67-426b-8957-65295e69c552/Start_Your_Project.ism/manifest',
                                type: 'application/vnd.ms-sstr+xml'
                                }]"/>
                            </b-col>

                            <b-col cols="12" class="px-4 mt-4">
                                <label class="text-high-contrast" for="name">
                                    {{getMessage(1, 'project-name', 2)}}</label>
                                <input aria-required="true" id="name" type="text" v-model="form.name"
                                    :placeholder="getMessage(1, 'project-name-placeholder', 2)"/>
                                <span v-if="nameError" class="form-error">This field is required</span>
                            </b-col>

                            <b-col cols="12" class="px-4 mt-3 instructional-text"
                                tabindex="0" aria-labelledby="problem-label problem">
                                <label id="problem-label">
                                    {{getMessage(1, 'project-problem', 2)}}
                                </label>
                                <span id="problem">{{getMessage(1, 'project-problem-placeholder', 2)}}</span>
                            </b-col>

                            <b-col cols="12" class="px-4 my-3 instructional-text"
                                tabindex="0" aria-labelledby="customer-label customer">
                                <label id="customer-label">
                                    {{getMessage(1, 'project-customer', 2)}}
                                </label>
                                <span id="customer">{{getMessage(1, 'project-customer-placeholder', 2)}}</span>
                            </b-col>
                        </b-row>
                    </b-col>
                </div>
                <b-row class="buttons justify-content-center pt-2" v-if="newProject" aria-controls="errors">
                    <b-col cols="12" md="8" class="pt-4">
                        <b-button block variant="primary" type="submit">Create my project</b-button>
                    </b-col>
                    <b-col cols="12" md="8" class="px-4 pt-2">
                        <b-button block variant="light" @click="$router.push({ name: 'home' })">Cancel</b-button>
                    </b-col>
                </b-row>
                <b-row class="buttons mt-3" v-else aria-controls="errors">
                    <b-col cols="6" md="3" offset-md="6" class="text-center">
                        <b-button block variant="light" size="lg" @click="$router.push({ name: 'home' })">Exit</b-button>
                    </b-col>
                    <b-col cols="6" md="3" class="pr-0 button-next">
                        <b-button block variant="primary" size="lg" type="submit" aria-label="Next">
                            Next
                            <img class="next-arrow" src="../../../core/Images/next_arrow.svg" alt="next" height="35"
                                width="35">
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-container>
        <div v-else class="start-project-wrapper">
            <div class="start-project">
                <b-container class="start-project-container">
                    <span class="start-project-container__title">{{getMessage(1, 'start-new-career-plan', 2)}}</span>
                    <b-col cols="12" class="start-project-group mt-4">
                        <label class="text-bold" for="name">
                            {{getMessage(1, 'project-name', 2)}}</label>
                        <input aria-required="true" id="name" type="text" v-model="form.name"
                            :placeholder="getMessage(1, 'project-name-placeholder', 2)"/>
                        <span v-if="nameError" class="form-error">This field is required</span>
                    </b-col>
                    <b-col cols="12" class="start-project-group mt-3"
                        tabindex="0" aria-labelledby="problem-label problem">
                        <label class="text-bold" id="problem-label">
                            {{getMessage(1, 'project-problem', 2)}}
                        </label>
                        <input id="name" type="text" v-model="form.problem"
                            placeholder="e.g., I am trying to choose one or more careers to pursue after high school."/>
                    </b-col>
                    <b-col cols="12" class="start-project-group my-3"
                        tabindex="0" aria-labelledby="customer-label customer">
                        <label class="text-bold" id="customer-label">
                            {{getMessage(1, 'project-customer', 2)}}
                        </label>
                        <input id="name" type="text" v-model="form.customer"
                            placeholder="e.g., I am the customer!"/>
                    </b-col>
                    <b-col cols="12" class="start-project-button pt-4">
                        <b-button class="btn-start" block variant="primary" @click="saveProject()">Start</b-button>
                    </b-col>
                     <div class="start-project-options">
                        <b-button class="btn-return" tabindex="0" block variant="outline-primary" :to="{ name: 'Projects' }">Return to My Plan</b-button>
                        <b-button class="btn-home" tabindex="0" block variant="outline-primary" :to="{ name: 'Activities' }">Home</b-button>
                        <b-button class="btn-links" tabindex="0" block variant="outline-primary" :to="{ name: 'QuickLinks' }">Quick Links</b-button>
                    </div>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
    import {Project, Storage} from "../../../core/Utils"
    import JAVideo from "../../../core/Components/JAVideo"

    export default {
        name: "StartProject",
        props: ['newProject'],
        components: {
            JAVideo,
        },
        data() {
            return {
                form: {
                    name: "",
                    problem: "",
                    customer: ""
                },
                nameError: false
            }
        },
        mounted() {
            if (!this.newProject) {
                const index = this.$route.params.index
                const projectData = Storage.getProject(index)
                this.form.name = projectData['name']
                this.form.problem = projectData['problem']
                this.form.customer = projectData['customer']
            }
        },
        methods: {
            saveProject() {
                this.nameError = this.form.name === ""
                if (this.nameError) return

                const index = this.$route.params.index

                Project.saveProject(
                    this.newProject, index, Project.PROJECT_JOB_SHADOW,
                    this.form.name, this.form.problem, this.form.customer, this.isOffline, this.isGuest
                ).then(response => {
                    this.$router.push({name: 'js_deep_customer_empathy_2', params: {index: response.index}})
                }).catch(err => {
                    this.$router.push({name: 'home'})
                })
            },
            onSettingsChange(newSettings) {
                this.settings.highContrast = newSettings.highContrast
            },
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .container
        margin-top -5px

    .button-next
        padding-right: 0

    .high-contrast
        .welcome
            color color-4

        .instructional-text
            label
                color black

        .text-high-contrast
            color black

    .wrapper-step-content
        min-height calc(100vh - 142px)

    .first-form
        background-color white
        border-radius 0 0 25px 25px
        box-shadow(0 1px 6px color-19)
        position relative
        z-index 3

    .welcome
        margin-top 38px
        font font-poppins-bold
        font-size 12px
        letter-spacing 1.2px
        color color-8

    .main-title
        font font-poppins-semibold
        font-size 18px
        letter-spacing 0.45px
        color black

    .instructional-text
        font font-sourcesans-regular
        font-size 16px
        letter-spacing 0
        color color-4

    .gradient
        margin-top -20px
        height 71px
        transform(matrix(-1, 0, 0, -1, 0, 0))
        background transparent linear-gradient(180deg, white 0%, color-1 100%) 0% 0% no-repeat padding-box

    .buttons
        margin-top 20px
        margin-bottom 28px

    .start-project-wrapper
        background-color color-1

        .start-project
            padding-bottom 3rem
            padding-top 20px

            &-container
                box-shadow(0px 1px 5px color-shadow)
                padding 25px 20px 30px 25px
                border-radius 25px
                background-color color-blank
                width 90%
                max-width none !important

                &__title
                    font font-poppins-semibold
                    font-size 22px
                    color color-dark

            &-group
                padding-left revert
                padding-right revert

                .text-bold
                    font font-poppins-semibold
                    color color-4
                    font-size 16px

            &-button
                display flex
                justify-content center

                .btn-start
                    width 200px
                    height 40px
                    min-height revert
                    border-radius 25px
                    border 2px solid color-green-light
                    background-color color-green-light
                    padding 0
                    &:hover
                    &:active
                        background-color color-green-dark !important


            &-options
                display flex
                align-items center
                margin-top 46px
                flex-direction column
                row-gap 20px

                .btn
                    width 260px
                    height 40px
                    margin 0px auto
                    border 2px solid color-green-light

                .btn-return
                .btn-home
                .btn-links
                    color color-green-light
                    font font-poppins-semibold
                    font-size 16px
                    &:hover
                        background-color color-green-dark !important
                        color color-blank

    @media (min-width: 576px)
        .container
            max-width 70% !important
            min-height initial

    @media (min-width: 767px)
        .pt-container
            padding-top 0.25rem !important

        .first-form
            border-radius 25px

        .buttons
            margin-top -20px

        .start-project-button
            justify-content start !important
            padding-left revert !important

        .button-next
            padding-right: 15px !important

    @media (min-width: 768px) and (max-width: 1200px)
        .start-project
            padding-top 30px !important

            &-container
                width 90% !important

            &-options
                flex-direction row !important
                column-gap 20px

                .btn-return
                .btn-home
                .btn-links
                    width 320px !important

    @media (min-width: 1200px)
        .start-project-wrapper
            background-color color-blank !important

            .start-project
                padding-top 36px !important

                &-container
                    padding 50px 50px 51px 50px !important
                    width 65%

                &-button
                &-group
                    padding-left 15px !important

                .btn
                    height 50px !important

                &-options
                    flex-direction row !important
                    column-gap 20px

                    .btn
                        width 320px !important

</style>
